import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Add, Delete, RestartAlt } from "@mui/icons-material";
import { Grid, IconButton, TextField, Typography } from "@mui/material";
import "./index.scss";
import { Downgraded } from "@hookstate/core";
import {
  setScheduleCallSheet,
  useCallSheetState,
  setUnSavedCallSheet,
  setDeletedSchedule,
} from "../../../../hooks/callSheet";
import { initialState } from "../../../../helper/schedule";
import TimeTool from "../../time-tool";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    borderRight: "1px solid #CFD3DD",
    opacity: 1,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    borderTop: "1.1px solid #CFD3DD",
    borderRight: "1px solid #CFD3DD",
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "td:last-child, th:last-child": {
    borderRight: 0,
  },
}));

const ScheduleTable = () => {
  const params = useParams();
  const { idCallsheet } = params;
  const [initial, setInitial] = useState(false);
  const callSheetState = useCallSheetState();
  const unsavedFlag = callSheetState.unsaved.get();
  callSheetState.attach(Downgraded);
  const rows = [...callSheetState.schedule.get()];
  const schedule = callSheetState.schedule.get();

  const removeRow = (index: number, id: any) => {
    if (!unsavedFlag) setUnSavedCallSheet(true);
    const newRows = JSON.parse(JSON.stringify(rows));
    newRows.splice(index, 1);
    setScheduleCallSheet(newRows);
    const deletedSchedule = callSheetState.deletedSchedule.get();
    if (deletedSchedule && idCallsheet && id) {
      setDeletedSchedule([...deletedSchedule, id]);
    }
  };

  const ResetTable = () => {
    if (idCallsheet) {
      const rowsCopy = JSON.parse(JSON.stringify(rows));
      const deleted = rowsCopy.map((item: any) => item.id);
      setDeletedSchedule(deleted);
    }
    const time = callSheetState.time.get();
    const rowsData = initialState.map((row: any) => ({ ...row, time }));
    setScheduleCallSheet(rowsData);
  };

  const updateTime = (e: any, rowId: any) => {
    const allRows = callSheetState.schedule.get();
    if (!unsavedFlag) setUnSavedCallSheet(true);
    const newRows = JSON.parse(JSON.stringify(allRows));
    const rowItem = newRows.find((row: any) => row.id === rowId);
    if (rowItem && idCallsheet && initial)
      rowItem.time = `${e.hour}:${e.mins} ${e.amPm}`;
    if (rowItem && !idCallsheet) rowItem.time = `${e.hour}:${e.mins} ${e.amPm}`;
    setScheduleCallSheet(newRows);
  };

  const updateRowItem = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    rowId: any,
    box: any
  ) => {
    const allRows = callSheetState.schedule.get();
    const newRows = JSON.parse(JSON.stringify(allRows));
    const rowItem = newRows.find((row: any) => row.id === rowId);
    if (rowItem) rowItem[box] = e.target.value;
    setScheduleCallSheet(newRows);
  };

  const addNewRow = () => {
    const allRows = callSheetState.schedule.get();
    const newRows = JSON.parse(JSON.stringify(allRows));
    const newRow = {
      id: uuidv4(),
      time: "",
      scene: "",
      description: "",
      cast: "",
      location: "",
    };
    newRows.push(newRow);
    setScheduleCallSheet(newRows);
  };
  useEffect(() => {
    setTimeout(() => {
      setInitial(true);
    }, 5000);
  }, []);

  return (
    <>
      {schedule && (
        <>
          <TableContainer
            component={Paper}
            className="schedule-table-container"
          >
            <Table
              sx={{ minWidth: 700 }}
              aria-label="customized table"
              className="schedule-table"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell className="schedule-table-header">
                    TIME
                  </StyledTableCell>
                  <StyledTableCell className="schedule-table-header">
                    SCENE
                  </StyledTableCell>
                  <StyledTableCell className="schedule-table-header">
                    DESCRIPTION
                  </StyledTableCell>
                  <StyledTableCell className="schedule-table-header">
                    CAST
                  </StyledTableCell>
                  <StyledTableCell className="schedule-table-header">
                    LOCATION
                  </StyledTableCell>
                  <StyledTableCell className="schedule-table-header">
                    ACTION
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <StyledTableRow
                    key={`${row.id}`}
                    hover
                    className="schedule-table-row"
                  >
                    <StyledTableCell
                      className="schedule-table-column"
                      component="th"
                      scope="row"
                    >
                      <TimeTool
                        size="small"
                        updateTime={(e: any) => updateTime(e, row.id)}
                        time={row.time}
                      />
                    </StyledTableCell>
                    <StyledTableCell className="schedule-table-column">
                      <TextField
                        className="unborder"
                        value={row.scene}
                        onChange={(e) => updateRowItem(e, row.id, "scene")}
                      />
                    </StyledTableCell>
                    <StyledTableCell className="schedule-table-column center">
                      <TextField
                        className="unborder"
                        multiline
                        maxRows={2}
                        value={row.description}
                        onChange={(e) =>
                          updateRowItem(e, row.id, "description")
                        }
                      />
                    </StyledTableCell>
                    <StyledTableCell className="schedule-table-column center">
                      <TextField
                        className="unborder"
                        multiline
                        maxRows={2}
                        value={row.cast}
                        onChange={(e) => updateRowItem(e, row.id, "cast")}
                      />
                    </StyledTableCell>
                    <StyledTableCell className="schedule-table-column center">
                      <TextField
                        className="unborder"
                        value={row.location}
                        onChange={(e) => updateRowItem(e, row.id, "location")}
                      />
                    </StyledTableCell>
                    <StyledTableCell className="schedule-table-column center">
                      <IconButton onClick={() => removeRow(index, row.id)}>
                        <Delete />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid
            container
            spacing={2}
            className="schedule-table-buttons"
          >
            <Grid
              item
              xs="auto"
            >
              <IconButton
                sx={{
                  border: "1px solid #858997",
                  borderRadius: "5px",
                }}
                onClick={addNewRow}
              >
                <Add
                  sx={{
                    color: "#858997",
                  }}
                  fontSize="small"
                />
              </IconButton>
            </Grid>
            <Grid
              item
              xs="auto"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography>Add line</Typography>
            </Grid>
            <Grid
              item
              xs="auto"
            >
              <IconButton
                sx={{
                  border: "1px solid #858997",
                  borderRadius: "5px",
                }}
                onClick={ResetTable}
              >
                <RestartAlt
                  sx={{
                    color: "#858997",
                  }}
                  fontSize="small"
                />
              </IconButton>
            </Grid>
            <Grid
              item
              xs="auto"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography>Reset</Typography>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default ScheduleTable;
